// Centro de costo con que el ledger imputa lo que paga un módulo a la wallet (bonos, premios,
// comisiones). Lo captura finanzas en la configuración de cada módulo; vacío = el pago se asienta
// sin asignar. Función pura compartida: la usan promociones de venta, de crédito y comisiones.

/** Espejo de `COST_CENTER_ID_MAX_LENGTH` de type-kit. */
export const COST_CENTER_MAX_LENGTH = 64;

export const COST_CENTER_LABEL = 'Centro de costo';

export const COST_CENTER_MESSAGES = {
    help: 'Con este centro el ledger imputa el pago; vacío = sin asignar.',
    tooLong: `Usa hasta ${String(COST_CENTER_MAX_LENGTH)} caracteres.`,
} as const;

/** Lo guardado como se teclea; sin centro, vacío. */
export function costCenterText(stored: string | null | undefined): string {
    return stored ?? '';
}

/** Al crear, el vacío no viaja: el back lo deja sin centro. */
export function costCenterForCreate(text: string): { costCenterId?: string } {
    const value = text.trim();
    return value === '' ? {} : { costCenterId: value };
}

/** Al editar, el vacío viaja en `null` para quitar el centro guardado. */
export function costCenterForUpdate(text: string): string | null {
    const value = text.trim();
    return value === '' ? null : value;
}

export function costCenterError(text: string): string | undefined {
    return text.trim().length > COST_CENTER_MAX_LENGTH ? COST_CENTER_MESSAGES.tooLong : undefined;
}
